export default {
    name: "collapse",
    functional: true,
    render(h, { children }) {
        var data = {
            on: {
                beforeEnter(el) {
                    if (!el.dataset) el.dataset = {}
                    let style = getComputedStyle(el, false);
                    console.log(style.overflow)
                    el.dataset.pre_paddingTop = style.paddingTop;
                    el.dataset.pre_paddingBottom = style.paddingBottom;
                    el.dataset.overflow = style.overflow;

                    el.style.height = 0;
                    el.style.overflow = 'hidden'
                    el.style.paddingBottom = 0;
                    el.style.paddingTop = 0
                },
                enter(el) {
                    el.style.height = `${el.scrollHeight}px`;
                    el.style.paddingTop = el.dataset.pre_paddingTop;
                    el.style.paddingBottom = el.dataset.pre_paddingBottom;

                },
                afterEnter(el) {
                    el.style.overflow = el.dataset.overflow;
                },
                beforeLeave(el) {
                    el.style.overflow = 'hidden'
                },
                leave(el) {
                    el.style.height = 0;
                    el.style.paddingBottom = 0;
                    el.style.paddingTop = 0
                },
                afterLeave(el) {
                    el.style.paddingTop = el.dataset.pre_paddingTop;
                    el.style.paddingBottom = el.dataset.pre_paddingBottom;
                    el.style.overflow = el.dataset.overflow;
                }
            },

        }
        return h('transition', data, children)
    }
}


// WEBPACK FOOTER //
// ./src/components/transition.js